module.exports = __webpack_public_path__ + "static/img/icon-table-setting.17442f9e.svg";